import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedGrid from './components/FeaturedGrid';
import ArticleHighlights from './components/ArticleHighlights';
import FAQSection from './components/FAQSection';

const homeStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '69视频',
  url: 'https://woaimiao.cn/',
  description: '69视频平台提供西瓜视频免费、91在线视频等影视在线观看入口，海量电影大全、电视剧全集、综艺节目高清播放不卡顿，免费在线观看体验。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://woaimiao.cn/category/dianying?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="69视频 | 西瓜视频免费与91在线视频 | 高清电影电视剧全集免费在线观看不缓冲"
        description="69视频平台提供西瓜视频免费、91在线视频等影视在线观看入口，海量电影大全、电视剧全集、综艺节目高清播放不卡顿，免费在线观看体验。"
        keywords="69视频,西瓜视频免费,西瓜视频,91在线视频,91视频网站,免费影视在线观看,高清电影在线播放,电视剧在线观看,综艺节目在线看"
        canonicalUrl="https://woaimiao.cn/"
        structuredData={homeStructuredData}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedGrid />
        <ArticleHighlights />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}